import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Actions, ofActionDispatched, Select, Store } from '@ngxs/store';
import { ExperienceUserExtended } from 'app/library/experience-user/models/experience-user.extended.model';
import { ExperienceUser } from 'app/library/experience-user/models/experience-user.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, take, tap } from 'rxjs/operators';
import { FetchExperienceUsers } from '../../actions';
import { ExperienceUsersState } from '../../models/experience-users.state';

export class ExperienceMemberDataSource implements DataSource<ExperienceUserExtended> {
    @Select(ExperienceUsersState.getFilteredEntities)
    filter$: Observable<ExperienceUserExtended>;
    private _data: ExperienceUserExtended[];

    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    get data() {
        return this._data;
    }

    constructor(private _filteredUser$: Observable<ExperienceUserExtended[]>, private _store: Store, private _action$: Actions) {}

    connect(collectionViewer: CollectionViewer): Observable<ExperienceUserExtended[]> {
        return this._filteredUser$.pipe(
            tap((filteredUsers) => {
                if (filteredUsers && filteredUsers.length) {
                }
                this._data = filteredUsers;
            })
        );
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._loadingSubject.complete();
    }

    loadUsers(experienceId?: string, search?: string, sortBy?: string, sortOrder?: string, pageSize?: number, pageNumber?: number): void {
        this._loadingSubject.next(true);
        this._store.dispatch(
            new FetchExperienceUsers({
                experienceId,
                search,
                sortBy,
                sortOrder,
                pageSize,
                pageNumber: pageNumber,
            })
        );

        this._action$
            .pipe(
                ofActionDispatched(FetchExperienceUsers),
                finalize(() => this._loadingSubject.next(false)),
                take(1)
            )
            .subscribe();
    }
}
